import { Route, Routes } from "react-router-dom";
import Jaktområder from "../Jaktomrader/Jaktomrader";
import MittJaktomrade from "../Jaktomrader/MittJaktomrade";
import Aldersbestemmelse from "./Aldersbestemmelse";
import JegeropplysningerForm from "./Components/JegeropplysningerForm";
import Minside from "./Components/MinSide";
import HjelpOgKontakt from "./HjelpOgKontakt/HjelpOgKontakt";
import Innstillinger from "./Innstillinger/Innstillinger";
import Kontakt from "./Kontakt";
import Om from "./Om";

export default function MinSide(): JSX.Element {
  return (
    <Routes>
      <Route index element={<Minside />} />
      <Route path="jegeropplysninger/*" element={<JegeropplysningerForm mode="rediger" />} />
      <Route path="kontakt/*" element={<Kontakt />} />
      <Route path="om/*" element={<Om />} />
      <Route path="aldersbestemmelse/*" element={<Aldersbestemmelse />} />
      <Route path="jaktomrader/*" element={<Jaktområder />} />
      <Route path="jaktomrade/*" element={<MittJaktomrade />} />
      <Route path="hjelpogkontakt/*" element={<HjelpOgKontakt />} />
      <Route path="innstillinger/*" element={<Innstillinger />} />
    </Routes>
  );
}
